import classNames from 'classnames'

export interface ClaimDetailsFieldProps {
  label: string
  /**
   * Pass an object to render string as html
   */
  value: string | number | { __html: string }
  className?: string
}

export const ClaimDetailsField: React.FC<ClaimDetailsFieldProps> = ({ label, value, className }) => {
  const valueIsHtml = Boolean((value as { __html: string }).__html)
  const wrapperClassNames = classNames('my-c-claim-details-field', className)
  return (
    <div className={wrapperClassNames}>
      <h3
        className='ds-u-font-size--md ds-u-font-weight--normal ds-u-margin-bottom--0'
      >
        {label}
      </h3>
      <span
        className='ds-u-font-size--lg ds-u-font-weight--semibold ds-u-word-break'
        dangerouslySetInnerHTML={valueIsHtml ? value as { __html: string } : undefined}
      >
        {!valueIsHtml ? value : undefined}
      </span>
    </div>

  )
}
